import { Route } from 'vue-router';

import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';

/**
 * Zwraca typy raportów
 *
 * @export
 * @param {*} [state]
 * @returns {any[]}
 */
export function getReportTypes(state?: any): any[] {
  if (!state) {
    state = store.state;
  }
  return JSON.parse(state.setting.settings[PublicSettings.HARDCODED_REPORTS]?.value || '[]');
}

/**
 * Zwraca wybrany typ raportu
 *
 * @export
 * @param {Route} route
 * @param {*} [state]
 * @returns {*}
 */
export function getSelectedReportType(route: Route, state?: any): any {
  return getReportTypes(state).find(type => type.id === route.query.type);
}
